var ChallengeRedirector = xClass("ChallengeRedirector", BaseRedirector)
ChallengeRedirector.prototype.getName = function () {
    return "challenge"
}
ChallengeRedirector.prototype.hasHighPriorityAction = function() {
    return false
}
ChallengeRedirector.prototype.isChallengeLegal = function (param) {
    let inviteCode, formerScore, issuerAvatar, challengeLevelId, timeStamp
    if (param) {
        inviteCode = param["inviteCode"]
        formerScore = param["formerScore"]
        issuerAvatar = param["issuerAvatar"]
        challengeLevelId = param["challengeLevelId"]
        timeStamp = param["timeStamp"]
    } else {
        inviteCode = getParameterByName("inviteCode")
        formerScore = getParameterByName("formerScore")
        issuerAvatar = getParameterByName("issuerAvatar")
        challengeLevelId = getParameterByName("challengeLevelId")
        timeStamp = getParameterByName("timeStamp")
    }
    if (!timeStamp) {
        return false
    }
    if (Localhost.timeInSec() > +timeStamp + 3600 * 48) {
        // if (_G.kIsNewUser || UserManager.getInstance().user.topLevelId < 5) {
        //     Toast.make("哎呀，挑战结束了。不怕，通过第5关即可发起挑战呦，加油", 2)
        // }else {
            Toast.make("当前挑战已经结束了", 1)
        // }
        return false
    }else {
        if (inviteCode) {
            if (+inviteCode === UserManager.getInstance().uid) {
                Toast.make("自己不能挑战自己的关卡哟！")
                return false
            } else if (formerScore && issuerAvatar && challengeLevelId) {
                return {
                    contestUid: +inviteCode,
                    formerScore: +formerScore,
                    issuerAvatar: HeDisplayUtil.urlDecode(issuerAvatar),
                    challengeLevelId: +challengeLevelId
                }
            }
        }
    }
    
    return false
}
ChallengeRedirector.prototype.redirect = function () {
    var self = this
    var param = self.param

    var scene = cc.Director.getInstance().getRunningScene()
    if (scene && scene.name === "HomeScene") {
        let challengeData = self.isChallengeLegal(param)
        if (challengeData) {
            var [logic, errCode] = require("clover/gamePlay/startEndLevelLogic/StartMainLevelLogic").create(challengeData.challengeLevelId, challengeData)
            if (!logic) {
                Toast.make(getText("error.tip." + tostring(errCode)))
            } else {
                logic.start(null, null, false)
                logic.startLevel()
            }
        }
        return true
    } else if (!scene || scene.name === "PreloadScene") {
        // PreloadScene特殊处理
        return true
    } else {
        Toast.make('在关卡内不能接受挑战哦~')
        return true
    }
}
module.exports = ChallengeRedirector